export const theme = {
  font: 'Inter',
  colors: {
    primary: {
      100: '#2A00A0',
      80: '#3E00DD',
      60: '#5B2DFF',
      40: '#765BFF',
      20: '#907EFF',
      10: '#F4EEFF',
    },
    green: {
      100: '#388E3C',
      80: '#4CAF50',
      60: '#81C784',
      40: '#A5D6A7',
      20: '#C8E6C9',
      10: '#F8FFF8',
    },
    red: {
      100: '#E64A19',
      80: '#FA5B2C',
      60: '#FF8A65',
      40: '#FFAB91',
      20: '#FFCCBC',
      10: '#FFCCBC',
    },
    orange: {
      100: '#FFA000',
      80: '#FFB300',
      60: '#FFD54F',
      40: '#FFE082',
      20: '#FFECB3',
      10: '#FFF8E1',
    },
    grey: {
      100: '#2C2C2C',
      90: '#424242',
      80: '#616161',
      70: '#757575',
      60: '#9E9E9E',
      50: '#BDBDBD',
      40: '#E0E0E0',
      30: '#EEEEEE',
      20: '#F5F5F5',
      10: '#FAFAFA',
      0: '#FFFFFF',
    },
  },
  spacing: {
    factor: 8,
    radius: 100,
    paddingHorizontal: 20,
    paddingVertical: 10,
    margin: 10,
  },
};
